export default function LoadingBar() {
  return <div className="loading-bar"></div>
}